import io from 'socket.io-client';

class WebRTC {

    constructor(props) {
        this.socket = null;
        this.token = null;
        this.source = null;
        this.remote = null;
        this.localStream = null;
        this.remoteStream = null;
        this.peerConn = null;
        this.webRTCStarted = false;
        this.blind = false;
        this.transfer = false;
        this.notifyVideoTrack = null;
        this.videoTrack = false;
        this.mediaConstraints = {
            'mandatory': {
                'OfferToReceiveAudio': true,
                'OfferToReceiveVideo': true
            }
        };

        this.mediaStreamConstraints = {
            audio: true,
            video: true
        };
        this.ring = null;
        this.ring = document.createElement('audio');
        this.ring.src = 'mp3/calling.mp3';
        this.ring.preload = 'auto';

        this.ring.loop = true;
        this.ring.load();
        this.ring.play();
        this.ring.pause();
        this.ring.currentTime = 0;
        
        window.addEventListener("beforeunload", function (event) {
            if (this.token != null) {
                this.hangup();
                this.sendMessage({ type: 'bye', value: this.token });
                this.token = null;
                this.socket.close();
                this.socket = null;
            }
        });
    }

    setRemote(remote) {
        this.remote = remote;
        if (!this.videoTrack)
            remote.parentElement.style.display = "none";
        if (this.remoteStream) {
            this.remote.srcObject = this.remoteStream;
            this.ring.pause();
            this.ring.currentTime = 0;
        }
    }

    setSource(source) {
        this.source = source;
        if (this.localStream)
            this.source.srcObject = this.localStream;
    }

    setVideoTrack(callBack) {
        this.notifyVideoTrack = callBack;
    }


    sendMessage = data => {
        var msg = JSON.stringify(data);
        console.log("SEND: " + msg);
        this.socket.emit("message", msg);
    }

    startSocket = (ext, userId) => {
        var guid = "";
        var chars = "abcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 6; i++)
            guid += chars.charAt(Math.floor(Math.random() * chars.length));

        if (this.localStream == null) {

            if (this.token == null) {

                this.token = ext + "_" + userId + "_" + guid;

                if (this.token.indexOf("__") !== -1) {

                    this.token = null;

                    setTimeout(function (ext, userId) {
                        this.startSocket();
                    }.bind(this), 1000);
                }
                else {
                    this.startSocket(ext, userId);
                }
            }
            else {

                let hostName = window.location.hostname;

                //! TODO: Trampa
                if (hostName === 'localhost' || hostName === '127.0.0.1' || hostName === 'dev.andrei.io')
                    hostName = "devomni.fidelitycloud.es";

                this.socket = io.connect("wss://" + hostName + ":1337", { query: "token=" + this.token });

                this.socket.on("message", function (event) {

                    this.socketOnMessage(event);
                }.bind(this));

                this.socket.on("disconnect", this.socketOnClose);

                setTimeout(function () {

                    if (!this.transfer && !this.blind) {
                        this.sendMessage({ type: 'token', value: this.token });
                        this.transfer = false;
                        this.blind = false;
                    }
                }.bind(this), 1000);
            }
        }
    }

    socketOnMessage = e => {

        console.log("RECEIVED: " + e);

        this.processSignalingMessage(e);
    }

    socketOnClose = () => {

        console.log('Socket closed');
    }


    createPeerConnection = () => {

        try {
            console.log("Creating peer connection");

            var servers = [];
            servers.push({ 'urls': 'stun:stun.l.google.com:19302' });
            servers.push({
                'urls': 'turn:82.223.102.162:3478',
                'credential': 'jusan',
                'username': 'jusan'
            });

            var pcConfig = { 'iceServers': servers };
            this.peerConn = new RTCPeerConnection(pcConfig);
            this.peerConn.onicecandidate = this.onIceCandidate;
        }
        catch (e) {
            console.error("Failed to create PeerConnection, exception: " + e.message);
        }

        this.peerConn.ontrack = this.onRemoteStreamAdded;
        this.peerConn.oniceconnectionstatechange = this.onIceConnectionStateChanges;
        this.peerConn.onremovestream = this.onRemoteStreamRemoved;
        this.peerConn.onnegotiationneeded = this.onNegotiationNeeded;
        this.peerConn.onsignalingstatechange = this.onSignalingStateChanges;
    }

    onRemoteStreamAdded = (event) => {

        console.log("Added remote stream");
        this.remoteStream = event.streams[0];

        if (this.remote) {
            this.remote.srcObject = event.streams[0];
            this.ring.pause();
            this.ring.currentTime = 0;
            if (event.streams[0].getVideoTracks().length && this.localStream.getVideoTracks().length) {

                this.remote.parentElement.style.display = "block";
                this.videoTrack = true;
                if (this.notifyVideoTrack)
                    this.notifyVideoTrack(true);

            }
            if (this.source)
                this.source.srcObject = this.localStream;
        }
    }

    onIceConnectionStateChanges = (event) => {

        if (this.peerConn != null) {

            console.log("ICE connection state: " + this.peerConn.iceConnectionState);
        }
    }

    onSignalingStateChanges = (event) => {

        if (this.peerConn != null) {

            console.log("Signaling state: " + this.peerConn.signalingState);
        }
    }

    onRemoteStreamRemoved = (event) => {

        console.log("Remove remote stream");
        this.remoteStream = null;
        this.videoTrack = false;
        if (this.notifyVideoTrack)
            this.notifyVideoTrack(false);
        if (this.remote) {
            this.remote.srcObject = null;
            this.ring.pause();
            this.ring.currentTime = 0;

            if (this.source)
                this.source.src = "";
        }
    }

    onNegotiationNeeded = () => {

        this.peerConn.createOffer(this.setLocalAndSendMessage, this.closeSession, this.mediaConstraints);
    }

    onIceCandidate = (event) => {

        if (event.candidate) {
            this.sendMessage({
                type: 'candidate',
                label: event.candidate.sdpMLineIndex,
                id: event.candidate.sdpMid,
                candidate: event.candidate.candidate
            });
        }
        else {
            console.log("End of candidates.");
        }
    }

    connect = () => {

        if (!this.transfer && !this.blind) {
            this.sendMessage({ type: 'token', value: this.token });
        }
        else if (this.transfer) {
            this.sendMessage({ type: 'transfer', value: this.token });
            this.transfer = false;
        }
        else {
            this.sendMessage({ type: 'blind', value: this.token });
            this.blind = false;
        }
        if (!this.webRTCStarted) {
            this.startVideo();
            this.webRTCStarted = true;
        }
    }

    processSignalingMessage = (message) => {

        var msg = JSON.parse(message);

        if (msg.type === 'offer') {

            if (!this.webRTCStarted) {
                this.startVideo();
                this.webRTCStarted = true;

                this.peerConn.setRemoteDescription(new RTCSessionDescription(msg));
                console.log("Sending answer to peer.");
                this.peerConn.createAnswer(this.setLocalAndSendMessage, this.closeSession, this.mediaConstraints);
            }
        }
        else if (msg.type === 'answer' && this.webRTCStarted) {
            this.peerConn.setRemoteDescription(new RTCSessionDescription(msg));
        }
        else if (msg.type === 'candidate' && this.webRTCStarted) {
            var candidate = new RTCIceCandidate({ sdpMLineIndex: msg.label, candidate: msg.candidate });
            this.peerConn.addIceCandidate(candidate).catch(
                e => console.error(e)
            );
        }
        else if (msg.type === 'hangup') {
            this.onRemoteHangUp();
        }
        else if (msg.type === 'connect') {
            this.connect();
        }
        else if (msg.type === 'ring') {
            this.remoteStream = null;

            if (this.remote) {
                this.remote.srcObject = null;
            }
            this.ring.play();
        }
        else if (msg.type === 'ringBlind') {
            this.remoteStream = null;

            if (this.remote) {
                this.remote.srcObject = null;
               
            }
            this.ring.play();
            this.blind = true;
            this.transfer = false;
        }
        else if (msg.type === 'ringTransfer') {
            this.remoteStream = null;

            if (this.remote) {
                this.remote.srcObject = null;
             
            }
            this.ring.play();
            this.transfer = true;
            this.blind = false;
        }
    }

    setLocalAndSendMessage = (sessionDescription) => {

        this.peerConn.setLocalDescription(sessionDescription);
        this.sendMessage(sessionDescription);
    }

    onRemoteHangUp = () => {

        console.log("Remote Hang up.");
        this.closeSession();
    }

    hangup = () => {

        this.sendMessage({ type: 'hangup', value: this.token });
        console.log("Hang up.");
        this.closeSession();
    }

    closeSession = () => {

        if (this.peerConn != null) {
            this.peerConn.close();
            this.peerConn.onicecandidate = null;
            this.peerConn.ontrack = null;
            this.peerConn.oniceconnectionstatechange = null;
            this.peerConn.onremovestream = null;
            this.peerConn.onnegotiationneeded = null;
            this.peerConn.onsignalingstatechange = null;
        }
        this.peerConn = null;
        if (this.localStream) {
            this.localStream.getTracks().forEach(function (track) {
                track.stop();
            });
            this.localStream = null;
        }
        this.webRTCStarted = false;
        this.remoteStream = null;

        this.videoTrack = false;
        if (this.notifyVideoTrack)
            this.notifyVideoTrack(false);

        if (this.remote) {
            this.remote.srcObject = null;
            this.ring.pause();
            this.ring.currentTime = 0;
        }

        if (this.source) {
            this.source.src = "";
        }
    }

    startVideo = () => {

        if (this.localStream === null) {

            if (this.token !== null) {

                this.createPeerConnection();
                setTimeout(function () {


                    navigator.mediaDevices.getUserMedia(this.mediaStreamConstraints)
                        .then(function (stream) {

                            this.localStream = stream;
                            console.log("Adding local stream...");
                            this.localStream.getTracks().forEach(function (track) {
                                this.peerConn.addTrack(track, this.localStream);
                            }.bind(this));
                        }.bind(this))
                        .catch(function (error) {

                            console.warn('An error occurred: [CODE ' + error.name + ']');

                            if (error.name === "NotFoundError") {

                                console.info('Trying get only audio device...');

                                this.mediaStreamConstraints.video = false;
                                navigator.mediaDevices.getUserMedia(this.mediaStreamConstraints)
                                    .then(function (stream) {

                                        this.localStream = stream;
                                        console.log("Adding local stream...");
                                        this.localStream.getTracks().forEach(function (track) {
                                            this.peerConn.addTrack(track, this.localStream);
                                        }.bind(this));
                                    }.bind(this))
                                    .catch(function (error) {

                                        alert('Unable to get media devices: [CODE ' + error.name + ']');
                                    }.bind(this)); /* eslint-disable-line */
                            }
                            else {

                                alert('Unable to get media devices: [CODE ' + error.name + ']');
                            }
                        }.bind(this));

                }.bind(this), 1000);
            }
        }
    }

}


const webRTC = new WebRTC();
export default webRTC;


